module.exports = __webpack_public_path__ + "img/customized SOP .0331cc05.jpg";